import React from 'react'

const About = () => {
    return (
        <>
            <h1>welcome to About page</h1>
        </>
    )
}

export default About
